import axiosInstance from "../../utils/axiosInstance";
import { getAuthHeaders } from "../../utils/authHeader";

const BASE_URL = `/integration-setting`;

export const createOrUpdateIntegrationSetting = async (data) => {
  const res = await axiosInstance.post(
    `${BASE_URL}/upsert`,
    data,
    getAuthHeaders(),
  );
  return res.data;
};

export const getIntegrationSettingByUser = async (search = "") => {
  const res = await axiosInstance.get(`${BASE_URL}/me`, {
    ...getAuthHeaders(),
    params: {
      search,
    },
  });

  return res.data;
};

export const deleteIntegrationSettingByUuid = async ({ uuid, deleteMode }) => {
  const params = new URLSearchParams();
  params.append("deleteMode", deleteMode);

  const res = await axiosInstance.delete(
    `${BASE_URL}/${uuid}?${params.toString()}`,
    getAuthHeaders(),
  );

  return res.data;
};

export const getIntegrationSettingByUuid = async (settingUuid) => {
  const res = await axiosInstance.get(
    `${BASE_URL}/id/${settingUuid}`,
    getAuthHeaders(),
  );
  return res.data;
};

export const getConfigurations = async (settingUuid) => {
  const res = await axiosInstance.get(
    `${BASE_URL}/configurations?settingId=${settingUuid}`,
    getAuthHeaders(),
  );
  return res.data;
};

export const refreshIntegrationSettingAPI = async (settingId = null) => {
  const res = await axiosInstance.get(`${BASE_URL}/refresh`, {
    ...getAuthHeaders(),
    params: { ...(settingId && { settingId }) },
  });

  return res.data;
};

export const getConversations = async () => {
  const res = await axiosInstance.get(
    `${BASE_URL}/conversations`,
    getAuthHeaders(),
  );

  return res.data;
};
